import { TREQUEST_ATTACHMENT_APPROVAL_LIST, TRESPONSE_ATTACHMENT_APPROVAL_LIST } from '@monorepo/types';
import moment from 'moment';
import { ModifiersZTableModel } from '../../table.modifier';
import { TTableRowNode } from '../../table.type';

const ACTION_TAKEN_BY_MAP: Record<TREQUEST_ATTACHMENT_APPROVAL_LIST['status'], string> = {
  IN_REPAIR: 'Raised By',
  REPAIR_APPROVED: 'Approved By',
  REPAIR_REJECTED: 'Rejected By',
};

export const ATTACHMENT_APPROVAL_TABLE_MODEL = {
  createModel: (
    data: TRESPONSE_ATTACHMENT_APPROVAL_LIST['attachmentRepairDetailList'],
    bucket: TREQUEST_ATTACHMENT_APPROVAL_LIST['status'],
  ) => {
    return ModifiersZTableModel.createTableModel(
      data,
      {
        headerConfig: [
          { type: 'TEXT_CELL', text: 'table_model.Date/Time', widthInPx: 150 },
          { type: 'TEXT_CELL', text: 'Machine Location', widthInPx: 150 },
          { type: 'TEXT_CELL', text: 'table_model.MACHINESERIALID', widthInPx: 150 },
          { type: 'TEXT_CELL', text: ACTION_TAKEN_BY_MAP[bucket], widthInPx: 150 },
          { type: 'TEXT_CELL', text: 'table_model.ATTACHMENT_SERIAL_ID', widthInPx: 150 },
        ],
        ...(bucket !== 'REPAIR_APPROVED'
          ? {
              select: {
                position: 'START',
                isMulti: true,
                size: 'DEFAULT',
              },
            }
          : {}),
      },
      (item): TTableRowNode<TRESPONSE_ATTACHMENT_APPROVAL_LIST['attachmentRepairDetailList'][number]> => ({
        type: 'ROW',
        rowItem: item,
        cells: [
          {
            type: 'TEXT_LIST_CELL',
            text: [
              moment(new Date(item.actionTakenAt)).format('YYYY/MM/DD'),
              moment(new Date(item.actionTakenAt)).format('hh:mm A'),
            ],
          },
          { type: 'TEXT_CELL', text: item.machineLocation ?? '- -' },
          { type: 'TEXT_CELL', text: item.machineSerialNumber },
          { type: 'TEXT_CELL', text: item.actionTakenBy },
          { type: 'TEXT_CELL', text: item.attachmentSerialNumber },
        ],
      }),
    );
  },
};
